const initialState = {
  theme: '',
  searchParams: null,
  userInfo: null,
  classInfo: null,
  businessInfo: null,
  videoInfo: null,
  replayInfo: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_THEME': // 主题，暂时无用
    case 'SET_SEARCH_PARAMS': // url上的查询参数
    case 'SET_USER_INFO': // 用户信息
    case 'SET_CLASS_INFO': // 课程信息：回放、录播
    case 'SET_BUSINESS_INFO': // 业务信息，主要处理知识点分享和游客模式
    case 'SET_VIDEO_INFO': // 视频信息
    case 'SET_REPLAY_INFO': // 获取回放是否过期、是否已奖励、星星回放任务规则、AI相关配置
    case 'SET_TOKEN':
    default:
      return {
        ...state,
        ...action.payload
      };
  }
};
